/* eslint-disable react-hooks/exhaustive-deps */

import React, {useContext, useEffect} from 'react';
import Configuration from './Configuration';
import VerificationPages from './VerificationPages';
import FraudCheckAccordion from './FraudCheck/FraudCheckAccordion';
import ConfirmationPage from './ConfirmationPage';
import Integration from './Integration';
import CostBreakdown from './CostBreakdown';
import {EasyOnboardContext} from '../../helpers/context';
import {useSelector} from 'react-redux';

function ConfigPanel({
  setSelectedApp,
  setCurrentPage,
  // setPages,
  pages,
  setFraudRules = () => {},
}) {
  const {widgetData, setWidgetData} = useContext(EasyOnboardContext);
  const {fraudRules} = useSelector(state => state?.widgets);

  useEffect(() => {
    const foundRule = fraudRules.find(rule => rule?.page === 'user_data');

    if (foundRule && foundRule?.isActive) {
      setFraudRules({
        page: 'user_data',
        isActive: true,
        user_data: {
          action: 'pending',
          two_names_rule: true,
        },
      });
    }
  }, [setFraudRules]);

  return (
    <>
      <div className="flex flex-col gap-4 relative pb-14">
        {/*<Application setApp={setSelectedApp} widgetData={widgetData} />*/}
        <Configuration setApp={setSelectedApp} widgetData={widgetData} />
        <VerificationPages setPage={setCurrentPage} pages={pages} />
        <FraudCheckAccordion setPage={setCurrentPage} />
        <ConfirmationPage
          setUrl={e => {
            const url =
              e.target.value.startsWith('https://') ||
              e.target.value.startsWith('http://')
                ? e.target.value
                : `https://${e.target.value}`;
            setWidgetData({...widgetData, redirect_url: url});
          }}
        />
        <CostBreakdown />
        <Integration setPage={setCurrentPage} />
      </div>
    </>
  );
}

export default ConfigPanel;
